import { render, staticRenderFns } from "./InputTableNoEditable.vue?vue&type=template&id=288f5350&scoped=true"
import script from "./InputTableNoEditable.vue?vue&type=script&lang=js"
export * from "./InputTableNoEditable.vue?vue&type=script&lang=js"
import style0 from "./InputTableNoEditable.vue?vue&type=style&index=0&id=288f5350&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288f5350",
  null
  
)

export default component.exports